import React, { useRef, useState } from "react";

import Modal from "react-bootstrap/Modal";
import axios from "axios";
import {
  validaMonto,
  formatMoneda,
  seleccionarCampo,
  validaSoloNumero,
} from "../../../util/varios";
import { Mensaje, MensajeSiNo } from "../../mensajes2";

import { Dimmer } from "../../spinner";
import moment from "moment";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
import { Checkbox, Input, Select, Textarea } from "../../../ui/inputs/Input";

export const IncluirMovimiento = (props) => {
  var op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
  const fechareal = JSON.parse(localStorage.getItem("fechareal"));
  const parametros = JSON.parse(localStorage.getItem("post"));
  const efiscalanio = JSON.parse(localStorage.getItem("efiscalanio"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const ip = JSON.parse(localStorage.getItem("ip"));
  const mac = JSON.parse(localStorage.getItem("mac"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const txtIdMovimiento = useRef();
  const txtDescripcion = useRef();
  const txtFecha = useRef();
  const txtFechaDocu = useRef();
  const txtFechaIngre = useRef();
  const txtReferencia = useRef();
  const cmbTipoMovimiento = useRef();
  const txtConcepto = useRef();
  const txtConcepto2 = useRef();
  const txtMonto = useRef();
  const chkTransferencia = useRef();

  const [idCuenta, setIdCuenta] = useState();
  const [operacion, setOperacion] = useState(0);
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({});
  const [visibleT, setVisibleT] = useState("hidden");

  const onChange = (e) => {
    if (e.target.name === "concepto") {
      e.target.value = e.target.value;
    } else {
      e.target.value = e.target.value;
    }
  };

  const cuentas_notas_debito = (id) => {
    let endpoint = `${op.conexion}/api/caja_ingreso/cuentasnotadebito?idcuentabancaria=${id}&efiscal=${idefiscal} `;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cuentas_bancarias_debi = (id) => {
    let endpoint = `${op.conexion}/api/caja_ingreso/cuentasbancariadebito?idcuentabancaria=${id}&efiscal=${idefiscal} `;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setActivate(false);
    setHabilitado(false);

    txtIdMovimiento.current.value = "";
    cmbTipoMovimiento.current.value = "";
    txtFechaDocu.current.value = "";
    txtFechaIngre.current.value = "";
    txtReferencia.current.value = "";
    txtConcepto.current.value = "";
    txtMonto.current.value = "";
    chkTransferencia.current.checked = false;
    setVisibleT("hidden");
  };

  const crearReversarAsiento = (idtransa, idmov) => {
    setActivate(true);
    let fecha = txtFechaIngre.current.value;
    if (operacion === 3) {
      fecha = fechasistema;
    }

    let endpoint = `${op.conexion}/api/Caja_Ingreso/asientodebitocreditodeposito`;

    let body = {
      operacion: operacion,
      ntipmov: cmbTipoMovimiento.current.value,
      idasi:
        operacion === 1
          ? "0"
          : props.registro.idasiento === null
            ? "0"
            : props.registro.idasiento,
      idtran:
        operacion === 1
          ? idtransa
          : cmbTipoMovimiento.current.value === "15"
            ? values.iddeposito
            : values.iddebitocredito,
      referen: txtReferencia.current.value,
      idcta: idCuenta,
      fec: fecha,
      nmonto: txtMonto.current.value.replace(/\./g, "").replace(",", "."),
      idefi: idefiscal,
      llamado: cmbTipoMovimiento.current.value === "15" ? "2" : "3",
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro " + idmov + " creado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                txtIdMovimiento.current.value +
                " modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                txtIdMovimiento.current.value +
                " reversado correctamente",
              icono: "exito",
            });
          } else if (operacion === 5) {
            //bitacoraEliminar()
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                txtIdMovimiento.current.value +
                " eliminado correctamente",
              icono: "exito",
            });
          }

          /*if (cmbTipoMovimiento.current.value !== '15') {
          moviminetosWeb()
        }*/
          setActivate(false);
          blanquear();
        }
      })
      .catch(function (error) {
        console.log(error.response.data.message);
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else if (error.response.data.message === "Asiento no generado.") {
          mensaje = "Asiento no generado.";
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro " + idmov + " creado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                txtIdMovimiento.current.value +
                " modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                txtIdMovimiento.current.value +
                " reversado correctamente",
              icono: "exito",
            });
          } else if (operacion === 5) {
            //bitacoraEliminar()
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                txtIdMovimiento.current.value +
                " eliminado correctamente",
              icono: "exito",
            });
          }

          /*if (cmbTipoMovimiento.current.value !== '15') {
          moviminetosWeb()
        }*/
          setActivate(false);
          blanquear();
          return;
        } else {
          mensaje = error.response.data.message;
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const procesarRegistro = () => {
    setActivate(true);

    let endpoint;
    let body;

    if (operacion === 1) {
      if (cmbTipoMovimiento.current.value !== "15") {
        body = {
          nid: 0,
          fech: txtFechaDocu.current.value,
          fecsis: fechasistema,
          refer: txtReferencia.current.value,
          motiv: txtConcepto.current.value.trim(),
          montot: txtMonto.current.value.replace(/\./g, "").replace(",", "."),
          m_nTipmov: cmbTipoMovimiento.current.value,
          m_nIdCta: idCuenta,
          fecingre: txtFechaIngre.current.value,
          ncaja: parametros.numcaja,
          concil: 0,
          btransfe: chkTransferencia.current.checked,
        };

        endpoint = `${op.conexion}/api/Caja_Ingreso/debitocreditocrear`;
      } else {
        body = {
          nid: 0,
          fecdepo: txtFechaDocu.current.value,
          fecsis: fechasistema,
          fecing: txtFechaIngre.current.value,
          obser: txtConcepto.current.value.trim(),
          ndepo: txtReferencia.current.value,
          montot: txtMonto.current.value.replace(/\./g, "").replace(",", "."),
          monefec: 0,
          moncheq: 0,
          m_nIdCta: idCuenta,
          m_nTipmov: cmbTipoMovimiento.current.value,
          especial: 0,
          ncaja: parametros.numcaja,
        };

        endpoint = `${op.conexion}/api/Caja_Ingreso/depositocrear`;
      }
    } else if (operacion === 2) {
      if (cmbTipoMovimiento.current.value !== "15") {
        body = {
          m_nIddebitocredito: values.iddebitocredito,
          m_nIdMov: txtIdMovimiento.current.value,
          m_nEfiscal: efiscalanio,
          m_nMonto: txtMonto.current.value.replace(/\./g, "").replace(",", "."),
          fec: txtFechaDocu.current.value,
          motiv: txtConcepto.current.value.trim(),
          btransfe: chkTransferencia.current.checked,
          fecIng: txtFechaIngre.current.value,
          fecsis: fechasistema,
        };

        /*update_movimientocontable()
        update_asiento_fecha()*/

        endpoint = `${op.conexion}/api/Caja_Ingreso/debitocreditomodificar`;
      } else {
        body = {
          m_nIddeposito: values.iddeposito,
          m_nIdMov: txtIdMovimiento.current.value,
          m_nEfiscal: efiscalanio,
          m_nMonto: txtMonto.current.value.replace(/\./g, "").replace(",", "."),
          fecdepo: txtFechaDocu.current.value,
          motiv: txtConcepto.current.value.trim(),
          fecIng: txtFechaIngre.current.value,
          fecsis: fechasistema,
        };

        endpoint = `${op.conexion}/api/Caja_Ingreso/depositomodificar`;
      }
    } else if (operacion === 3) {
      if (cmbTipoMovimiento.current.value !== "15") {
        body = {
          m_nIddebitocredito: values.iddebitocredito,
          m_nIdMov: txtIdMovimiento.current.value,
          m_nEfiscal: efiscalanio,
          motivor: txtConcepto2.current.value.trim(),
          fecrev: fechasistema,
        };

        //actualizarAsiento()

        endpoint = `${op.conexion}/api/Caja_Ingreso/debitocreditoreversar`;
      } else {
        body = {
          m_nIddeposito: values.iddeposito,
          m_nIdMov: txtIdMovimiento.current.value,
          m_nEfiscal: efiscalanio,
          motivor: txtConcepto2.current.value.trim(),
          fecsis: fechasistema,
        };

        endpoint = `${op.conexion}/api/Caja_Ingreso/depositoreversar`;
      }
    } else if (operacion === 5) {
      if (cmbTipoMovimiento.current.value !== "15") {
        body = {
          m_nIddebitocredito: values.iddebitocredito,
          m_nIdMov: txtIdMovimiento.current.value,
          //m_nEfiscal: efiscalanio,
          fecope: moment.utc(txtFecha.current.value).format("YYYY-MM-DD"),
          numdoc: values.referencia,
          mondoc: txtMonto.current.value.replace(/\./g, "").replace(",", "."),
          idcuenta: idCuenta,
          idusu: idusuario,
          fecsis: fechasistema,
          fecreal: fechareal,
          cdirip: ip,
          cdirmac: mac,
        };

        /*if (cmbTipoMovimiento.current.value === '16') {
          delete_movicontaxasiento()
        }*/

        endpoint = `${op.conexion}/api/Caja_Ingreso/debitocreditoeliminar`;
      } else {
        body = {
          m_nIddeposito: values.iddeposito,
          m_nIdMov: props.idmovimiento,
          //m_nEfiscal: efiscalanio,
          fecope: moment.utc(txtFecha.current.value).format("YYYY-MM-DD"),
          numdoc: values.referencia,
          mondoc: txtMonto.current.value.replace(/\./g, "").replace(",", "."),
          idcuenta: idCuenta,
          idusu: idusuario,
          fecsis: fechasistema,
          fecreal: fechareal,
          cdirip: ip,
          cdirmac: mac,
        };

        endpoint = `${op.conexion}/api/Caja_Ingreso/depositoeliminar`;
      }
    }

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          /*if (operacion === 1) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro ' + (cmbTipoMovimiento.current.value !== '15' ? response.data[0].crear_debitocredito : response.data[0].crear_deposito) + ' creado correctamente', icono: 'exito' });
        } else if (operacion === 2) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro ' + txtIdMovimiento.current.value + ' modificado correctamente', icono: 'exito' });
        } else if (operacion === 3) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro ' + txtIdMovimiento.current.value + ' reversado correctamente', icono: 'exito' });
        } else if (operacion === 5) {
          //bitacoraEliminar()
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro ' + txtIdMovimiento.current.value + ' eliminado correctamente', icono: 'exito' });
        }*/

          /*if (cmbTipoMovimiento.current.value !== '15') {
          moviminetosWeb()
        }*/
          /*setActivate(false);
        blanquear();*/
          crearReversarAsiento(
            cmbTipoMovimiento.current.value !== "15"
              ? response.data[0].iddebcre
              : response.data[0].iddepo,
            response.data[0].nidmov
          );
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "ubicacion_key"'
          ) {
            mensaje = "Ya existe un Registro con este rif";
          } else if (
            error.response.data.message ===
            'update or delete on table "deposito" violates foreign key constraint "deposito_id" on table "chequexdeposito"'
          ) {
            mensaje = "Este Deposito no Se puede Eliminar";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeValidar = () => {
    let sigue = true;
    if (cmbTipoMovimiento.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Tipo de Movimiento",
        icono: "informacion",
      });
      cmbTipoMovimiento.current.focus();
      sigue = false;
    } else if (txtFechaDocu.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la Fecha del Documento",
        icono: "informacion",
      });
      txtFechaDocu.current.focus();
      sigue = false;
    } else if (txtFechaIngre.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la fecha de Ingreso",
        icono: "informacion",
      });
      txtFechaIngre.current.focus();
      sigue = false;
    } else if (
      txtReferencia.current.value === "" &&
      operacion !== 3 &&
      operacion !== 5
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la Referencia",
        icono: "informacion",
      });
      txtReferencia.current.focus();
      sigue = false;
    } else if (txtConcepto.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Concepto de Movimiento",
        icono: "informacion",
      });
      txtConcepto.current.focus();
      sigue = false;
    } else if (operacion === 3 && txtConcepto2.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Motivo del Reverso",
        icono: "informacion",
      });
      txtConcepto2.current.focus();
      sigue = false;
    } else if (
      txtMonto.current.value === "" ||
      (txtMonto.current.value === "0,00" && operacion !== 3 && operacion !== 5)
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Monto de Movimiento",
        icono: "informacion",
      });
      txtMonto.current.focus();
      sigue = false;
    }

    if (sigue) {
      procesarRegistro();
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }

    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };
  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      setHabilitado(false);
      txtIdMovimiento.current.setAttribute("disabled", true);
      setTimeout(() => txtDescripcion.current.focus(), 200);
    } else if (op === 2) {
      txtIdMovimiento.current.removeAttribute("disabled");
      setHabilitado(false);
      txtIdMovimiento.current.focus();
    } else if (op === 3) {
      setHabilitado(true);
      txtIdMovimiento.current.removeAttribute("disabled");
      txtIdMovimiento.current.focus();
    } else if (op === 4) {
      setHabilitado(true);
      txtIdMovimiento.current.removeAttribute("disabled");
      txtIdMovimiento.current.focus();
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    } else if (op === 7) {
      cancelar();
    }
  };

  const cerrarModal = () => {
    props.onHideRenderizar();

    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.which === 13) {
      if (event.target.name === "fechadoc") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
        txtFechaIngre.current.focus();
      } else if (event.target.name === "fechaingre") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
        txtReferencia.current.focus();
      } else if (event.target.name === "refe") {
        txtConcepto.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.name === "fechadoc") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
      } else if (event.target.name === "fechaingre") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const mostrarC = () => {
    if (cmbTipoMovimiento.current.value === "17") {
      setVisibleT("visible");
    } else {
      setVisibleT("hidden");
    }
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setHabilitado(props.habilitado);
        if (props.operacion === 1) {
          setIdCuenta(props.idCuenta);
          cuentas_notas_debito(props.idCuenta);
          cuentas_bancarias_debi(props.idCuenta);
        } else {
          if (props.operacion === 5) {
            //seleccionarRegistro(props.registro.idasiento)
          }

          if (props.registro.tipo !== "15" && props.registro.idasiento) {
            //detalle_asiento(props.registro.idasiento)
          } else {
          }
          setValues(props.registro);
          setIdCuenta(props.idCuenta);
          txtFecha.current.value = moment.utc(props.registro.fechasis).format(
            "YYYY-MM-DD"
          );
          txtIdMovimiento.current.value = props.idmovimiento;
          cmbTipoMovimiento.current.value = props.registro.tipo;

          txtFechaDocu.current.value =
            props.registro.tipo !== "15"
              ? moment.utc(props.registro.fecha).format("YYYY-MM-DD")
              : moment.utc(props.registro.fechadeposito).format("YYYY-MM-DD");
          txtFechaIngre.current.value = moment.utc(
            props.registro.fechaingreso
          ).format("YYYY-MM-DD");

          txtReferencia.current.value =
            props.registro.tipo === "15"
              ? props.registro.numdeposito.trim()
              : props.registro.referencia.trim();
          txtConcepto.current.value =
            props.registro.tipo === "15"
              ? props.registro.observaciones.trim()
              : props.registro.motivo.trim();
          txtMonto.current.value =
            props.registro.tipo === "15"
              ? formatMoneda(
                props.registro.montototal
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              )
              : formatMoneda(
                props.registro.monto
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
          if (props.registro.reversado === "1") {
            txtConcepto2.current.value = props.registro.motivoreverso.trim();
          }

          if (props.registro.tipo === "17") {
            setVisibleT("visible");
            chkTransferencia.current.checked = props.registro.transferencia;
          } else {
            setVisibleT("hidden");
            chkTransferencia.current.checked = false;
          }
        }
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>
          {operacion === 1
            ? "Agregar Movimiento Bancario."
            : operacion === 2
              ? "Editar Movimiento Bancario."
              : operacion === 3
                ? "Reversar Movimiento Bancario."
                : operacion === 5
                  ? "Eliminar Movimiento Bancario."
                  : "Consultar Contribuyente."}
        </h3>
        <a type="button" onClick={cancelar}>
          salir<i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body style={{ height: "300px", overflowY: "auto" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito." ||
              mensaje.texto === "Asiento no generado."
              ? cerrarModal()
              : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate}></Dimmer>
        <div className="col-12 p-2 m-0 d-flex flex-wrap">
          <div className="col-3 p-0 m-0 mb-2">
            <Input label="Id Movimiento:" disabled ref={txtIdMovimiento} />
          </div>
          <div className="col-6 p-0 m-0"></div>
          <div className="col-3 p-0 m-0 mb-2">
            <Input
              label="Fecha:"
              type="date"
              disabled
              defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
              ref={txtFecha}
            />
          </div>
          <div className="col-4 p-0 m-0">
            <Select
              label="Tipo Movimiento:"
              disabled={operacion === 1 ? false : true}
              onChange={mostrarC}
              ref={cmbTipoMovimiento}
              options={[
                { value: "", label: "--" },
                { value: "15", label: "Deposito" },
                { value: "16", label: "Nota Debito" },
                { value: "17", label: "Nota Credito" },
              ]}
            />
          </div>
          <div className="col-4 p-0 m-0 px-2">
            <Input label='Fecha Documento:'
              type="date"
              disabled={!habilitado}
              defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
              name="fechadoc"
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
              ref={txtFechaDocu}
            />
          </div>
          <div className="col-4 p-0 m-0">
            <Input label='Fecha Ingreso:'
              type="date"
              disabled={!habilitado}
              defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
              name="fechaingre"
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
              ref={txtFechaIngre}
            />
          </div>
          <div className="col-4 p-0 m-0 mt-2">
            <Input label='Referencia:'
              disabled={operacion === 1 ? false : true}
              name="refe"
              onChange={handleInputNumChange}
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
              ref={txtReferencia}
            />
          </div>
          <div className={visibleT !== 'hidden'
            ? "col-4 p-0 pl-2 m-0 d-flex align-items-center gap-2"
            : 'd-none'}>
            <Checkbox label='Transferencia'
              readOnly
              disabled={!habilitado}
              id="checLiquidador"
              ref={chkTransferencia}
              defaultChecked={
                props.registro ? props.registro.transferencia : false
              }
            />
          </div>
          <div className="col-12 p-0 m-0 mt-2">
            <Textarea label='Concepto:'
              style={{ height: 70 }}
              disabled={!habilitado}
              name="concepto"
              onChange={onChange}
              ref={txtConcepto}
            />
          </div>
          {operacion === 3 ||
            (props.registro && props.registro.reversado === "1") &&
            <div className="col-12 p-0 mt-2">
              <Textarea label='Motivo del Reverso:'
                style={{ height: 70 }}
                disabled={operacion === 3 ? false : true}
                name="concepto"
                onChange={onChange}
                ref={txtConcepto2}
              />
            </div>
          }
          <div className="col-3 p-0 m-0 ml-auto mt-2">
            <Input label='Monto:'
              inputClassName='text-end'
              defaultValue={"0,00"}
              disabled={!habilitado}
              onFocus={seleccionarCampo}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              ref={txtMonto}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={operacion === 4 ? true : false}
          onClick={onBotones(5)}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={onBotones(7)}>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
};
